<div class="confirmation-error justify-content-center h-100">
    <div class="content h-100">
        <div class="content-icon">
            <i class="icon-edponline-Bra-072 custom-icon"></i>
        </div>
        <p class="description">
            {{ "pt.edp.edponline.confirmation.error.label" | translate }}
        </p>
        <div class="custom-buttons">
            <button class="custom-buttom" (click)="goBack()">
                {{ "pt.edp.edponline.acceptance.agreement.buttom" | translate }}
            </button>
        </div>
    </div>
</div>
